module.exports = __webpack_public_path__ + "img/map.8a71f0d3.png";